import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'

const ResetRatesMenuItem = ({supplier = null, refetch, disabled}) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    if (confirm(formatMessage(messages.confirm))) {
      fetch(`/supplier/resetOnboarding.json?supplierId=${supplier.uid}`, { method: 'DELETE' })
        .then((response) => response.json())
        .then(({ errors, success }) => {
          if (success) {
            refetch()
            toastr.success(`${supplier.userid}'s rates was reset`)
          } else {
            toastr.error(errors.join(' '))
          }
        })
        .catch((error) => window.alert(error))
    }
  }

  return (
    <Menu.Item disabled={disabled}>
      <MenuButton disabled={disabled} state="negative" onClick={onClick}>
        { formatMessage(messages.resetRates) }
      </MenuButton>
    </Menu.Item>
  )
}

export default ResetRatesMenuItem
